import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';

export type SearchFilterBookingPreferenceKey = {
  [Key in keyof FilterState]: FilterState[Key] extends boolean ? Key : never;
}[keyof FilterState];

export interface SearchFilterBookingPreference {
  key: SearchFilterBookingPreferenceKey;
  label: string;
  analyticsKey: string;
  testIdValue: string;
}

export const FOLLOW_UP_ANALYTICS_KEY = 'aceita_retorno';

export const ONLY_SCHEDULED_ANALYTICS_KEY = 'somente_hora_marcada';

export const searchFilterBookingPreferences: readonly SearchFilterBookingPreference[] = [
  {
    key: 'followUp',
    label: 'Profissionais que aceitam retorno',
    analyticsKey: FOLLOW_UP_ANALYTICS_KEY,
    testIdValue: 'follow-up',
  },
  {
    key: 'onlyScheduled',
    label: 'Somente hora marcada',
    analyticsKey: ONLY_SCHEDULED_ANALYTICS_KEY,
    testIdValue: 'only-scheduled',
  },
];
